// crm/utils/PrivateRoute.js (updated for v7.4.0)
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {

  const { token } = useSelector((state) => state.auth);

  return token ? <Outlet /> : <Navigate to="/signIn" replace />;
};

export default PrivateRoute;
